<button class="linklike" id="back">&larr; Retour</button>
<div class="staticHeader">
  <img class="staticCover" id="staticCover" alt="" loading="lazy" onerror="this.classList.add('noImage')" />
  <div class="seriesInfo">
    <span class="staticBadge">Lounge party</span>
    <h1 id="staticTitle"></h1>
    <p class="hint staticMeta" id="staticMeta"></p>
    <div class="staticProgress" aria-hidden="true"><div class="staticProgressFill" id="staticProgressFill"></div></div>
    <p class="staticNext" id="staticNext"></p>
    <div class="staticActions">
      <button id="sessionBtn">Lancer la séance</button>
      <button class="secondaryBtn hide" id="joinBtn">Rejoindre cette lounge party</button>
      <button class="linklike hide" id="leaveBtn">Quitter</button>
      <button class="linklike hide" id="deleteBtn">Supprimer</button>
    </div>
  </div>
</div>

<section class="section staticMissed" id="missedSection" hidden>
  <div class="staticSectionHead">
    <h2>Tu as manqué <span class="staticCount" id="missedCount"></span></h2>
    <div class="staticBulkActions">
      <button class="secondaryBtn" id="catchUpSoloBtn">Rattraper en solo</button>
      <button class="secondaryBtn" id="catchUpPartyBtn">Lancer une watch party de rattrapage</button>
    </div>
  </div>
  <p class="hint">Décoche ce que tu ne veux pas rattraper tout de suite.</p>
  <div class="episodeList" id="missedList"></div>
</section>

<section class="section">
  <h2>Membres</h2>
  <div class="staticMembers" id="memberList"></div>
</section>

<section class="section">
  <h2>Progression du groupe</h2>
  <div class="episodeList" id="itemList"></div>
</section>
